<template>
  <div class="modal-window">
    <header class="modal-header">
      <button @click="$emit('close')" class="btn_close">닫기</button>
    </header>
    <div class="modal-content">
      <div class="content comment">
        <div>
            <ProjectComment
              :callFrom="'projectContents'"
              :projectId="projectId"
              :groupId="groupId"
              :userId="userId"
              :memberList="memberList"
            />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import ProjectComment from "@/components/cowork/general/project/modal/ProjectComment";

export default {
  components: {
    ProjectComment,
  },
  props: {
    modal: Object,
    modalInfo: Object,
  },
  data() {
    let param = this.modalInfo.param;
    return {
      projectId: param.projectId,
      groupId: param.groupId,
      userId: param.userId,
      unReadComment: param.unReadComment,
      memberList: [],
    }
  },
  watch: { },
  mounted() {
    console.log(this.modalInfo.param);
    this.getMemberlist();
  },
  methods: {
    ...mapActions("restAction", ["COWORK_REST_ACTION"]),
    /* 멤버  */
    getMemberlist() {
      let self = this;
      let reqData = {};
      reqData.req = {
        groupId: self.groupId,
      };
      let memberList = self.memberList;
      memberList.splice(0, memberList.length);
      reqData.url = "/api/cogroup/cogroupUser/getCogroupUserList";
      reqData.method = "post";
      self
        .COWORK_REST_ACTION(reqData)
        .then((res) => {
          // console.log(res);
          if (res.errorCode) {
            console.log(res.errorCode);
          } else {
            if (res.result && res.result.data) {
              res.result.data.forEach(item => {
                memberList.push(item);
              });
            }
            let inx = self.unReadComment.indexOf(self.projectId);
            if (inx != -1) {
              self.unReadComment.splice(inx, 1);
            }
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },
  }
}
</script>
<style scoped>
.modal-content {
  background: #f6f7fa;
  padding: 35px 0 0 0;
  height: 560px;
}
.modal-content .content.comment {
    position: absolute;
    contain: content;
    width: auto;
    height: auto;
    border-color: #d3d4d6;
    overflow-y: auto;
    overflow-x: hidden;
}

.modal-content .content.comment > div {
  display: block;
  position: static;
  width: 340px;
  height: 595px;
}

.modal-content .opinion_search {
  position: relative;
  left: 0;
  top: -40px;
  height: 600px;
}
</style>


// WEBPACK FOOTER //
// src/components/cowork/general/project/modal/ProjectCommentModal.vue